export var PRODUCTS_MAX_NUMBER = 100;
export var CREATORS_MAX_NUMBER = 50;
export var SELECT_CREATOR_TABLE_CLASS_NAME = 'invitation-select-creator-table';